import Util from '@/utils/util'
import Axs from '@/utils/axs'
import {defineStore} from 'pinia'
import storeInfoFun from '@/info.js'

let storeFunc = defineStore("page1",{
    state:()=>{
        return {
           //业务数据  count:99
           openedfunsViewArr:[],
           tabSelected:"",
           funsLayout:"",
           funsLayoutTitle:"",
           funsLayoutSearchs:null,
           treeData:null,
           
           ComfirEnum: [{
            id: 0,
            label: "否"
            },
            {
                id: 1,
                label: "是"
            }],
            IdentityTypeEnum: [{
                id: 1,
                label: "身份证"
            },
            {
                id: 2,
                label: "护照"
            },
            {
                id: 3,
                label: "港澳台通行证"
            }],
            SexEnum:[
                {
                    id: 0,
                    label: "未输入"
                },
                {
                    id: 1,
                    label: "男"
                },
                {
                    id: 2,
                    label: "女"
                },
            ],
        }
    },
    actions:{
        clear()
        {
            //console.log("openedfunsViewArr清理了3333333333333?????????????")
            this.openedfunsViewArr =[];
            this.tabSelected="";
            this.funsLayout ="";
            this.funsLayoutTitle ="";
            this.funsLayoutSearchs = null;
            this.treeData =null;
        }
    },
    getters:{
        //计算属性，只读属性
    },
    persist: true
})

 //组合式写法 mixin混合写法
// let storeFunc = defineStore("user",()=>{
//     //组合式写法
//     let p = ref("xx");
//     return {
//         p
//     }
// })


export default storeFunc